import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import InfoSVG from "../../../assets/navbar/Convenios_on_light_blue.svg";
import StatusModal from "../modal/StatusModal";
import OpinionModal from "../modal/OpinionModal";
import ErrorModal from "../modal/ErrorModal";
import HistoryModal from "../modal/HistoryModal";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboardCheck,
  faSearch,
  faUserCheck,
  faFileAlt,
  faHistory,
} from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../../context/globalContext";
import { Portal } from "../Portal";

import {
  SvgIcon,
  DropdownTitleCustom,
  DropdownItemCustom,
  DropdownMenuCustom,
  DropdownCustom,
} from "./styles";

const Menu = ({ ...props }) => {
  const history = useHistory();
  const { numeroProposta, cpfCnpj, nomeCliente, descricaoStatus, updateTable } =
    props;

  const [hidden, setHidden] = useState(true);
  const [loading, setLoading] = useState(false);
  const [opinionModalOpen, setOpinionModalOpen] = useState(false);
  const [opinionModalData, setOpinionModalData] = useState({});
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [status, setStatus] = useState([]);
  const [statusLoading, setStatusLoading] = useState(true);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const { loadingOverlayActive, setLoadingOverlayActive } = useContext(Context);
  const assumeAvailable =
    [
      "Análise Completa I",
      "Analise Completa II",
      "Análise Completa Mandatória",
      "Reanálise",
      "Análise Completa com Dispensa de Renda",
      "Partes Relacionadas",
    ].indexOf(descricaoStatus) !== -1;

  const loadData = async (url) => {
    return api
      .get(url)
      .then((response) => {
        if (response && (response.status === 201 || response.status === 200)) {
          return response.data;
        }
        if (!response) {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados.");
        }
      });
  };

  const onViewProposal = (e) => {
    history.push(`/visualizar-proposta/${numeroProposta}/${cpfCnpj}`);

    setHidden(true);
  };

  const onChangeHistoryModal = () => {
    setHidden(true);
    setStatusLoading(true);
    setHistoryModalOpen(true);
  };

  const onChangeStatus = () => {
    setHidden(true);
    setLoadingOverlayActive(true);
    setStatusLoading(true);
    loadData(
      `/api/front-credito/status-possiveis-proposta?numeroProposta=${numeroProposta}`
    )
      .then((data) => {
        setStatus(data);
        if (data.length === 0) {
          setErrorModalOpen(true);
        } else {
          setStatusModalOpen(true);
        }
      })
      .catch(() => setStatus([]))
      .finally(() => {
        setLoadingOverlayActive(false);
        setStatusLoading(false);
      });
  };

  const onAssumeProposal = () => {
    setHidden(true);
    setLoadingOverlayActive(true);
    loadData(
      `/api/front-credito/assumir-proposta?numeroProposta=${numeroProposta}`
    )
      .then((data) => {
        history.push(`/visualizar-proposta/${numeroProposta}/${cpfCnpj}`);
        if (data?.status) {
          toast.success("Proposta assumida com sucesso!");
        } else {
          toast.error(
            data?.error ?? "Ocorreu um erro inesperado ao assumir a proposta."
          );
        }
      })
      .finally(() => setLoadingOverlayActive(false));
  };

  const onViewLastOpinion = () => {
    setHidden(true);
    setOpinionModalOpen(true);
    setLoading(true);
    loadData(
      `/api/front-credito/ultimo-parecer?numeroProposta=${numeroProposta}`
    )
      .then((parecer) => {
        if (parecer) {
          setOpinionModalData({
            sequencia: parecer.numeroSequencia,
            tipoParecer: parecer.descricaoTipo,
            decisao: parecer.codidoTipoDecisao,
            nomeUsuario: parecer.nomeUsuario,
            dataHora: parecer.dataInclusao,
            parecer: parecer.descricao,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <DropdownCustom>
        <SvgIcon src={InfoSVG} onClick={() => setHidden(!hidden)} />
        <DropdownMenuCustom hidden={hidden} toggle={() => setHidden(!hidden)}>
          <DropdownTitleCustom id="proposta"> Proposta</DropdownTitleCustom>
          {!assumeAvailable && (
            <DropdownItemCustom id="visualizar" onClick={onViewProposal}>
              <FontAwesomeIcon icon={faSearch} /> Visualizar
            </DropdownItemCustom>
          )}
          {assumeAvailable && (
            <DropdownItemCustom id="assumirProposta" onClick={onAssumeProposal}>
              <FontAwesomeIcon icon={faClipboardCheck} /> Assumir proposta
            </DropdownItemCustom>
          )}
          <DropdownItemCustom id="alterarStatus" onClick={onChangeStatus}>
            <FontAwesomeIcon icon={faUserCheck} /> Alterar status
          </DropdownItemCustom>
          {!assumeAvailable && (
            <DropdownItemCustom id="ultimoParecer" onClick={onViewLastOpinion}>
              <FontAwesomeIcon icon={faFileAlt} /> Último Parecer
            </DropdownItemCustom>
          )}
          <DropdownItemCustom id="history" onClick={onChangeHistoryModal}>
            <FontAwesomeIcon icon={faHistory} /> Histórico
          </DropdownItemCustom>
        </DropdownMenuCustom>
      </DropdownCustom>
      <StatusModal
        open={statusModalOpen}
        onClose={() => setStatusModalOpen(false)}
        numeroCpfCnpj={cpfCnpj}
        nomeDoCliente={nomeCliente}
        numeroProposta={numeroProposta}
        status={status}
        statusLoading={statusLoading}
        updateTable={updateTable}
      />
      <OpinionModal
        open={opinionModalOpen}
        loading={loading}
        onClose={() => setOpinionModalOpen(false)}
        sequencia={opinionModalData.sequencia}
        tipoParecer={opinionModalData.tipoParecer}
        decisao={opinionModalData.decisao}
        nomeUsuario={opinionModalData.nomeUsuario}
        dataHora={opinionModalData.dataHora}
        parecer={opinionModalData.parecer}
      />
      <ErrorModal
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
      />
      <Portal>
        {historyModalOpen && (
          <HistoryModal
            open={historyModalOpen}
            onClose={() => {
              setHistoryModalOpen(false);
            }}
            numeroProposta={numeroProposta}
            cpfCnpj={cpfCnpj}
            nomeCliente={nomeCliente}
          />
        )}
      </Portal>
    </>
  );
};

export default Menu;
